import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const faxColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'fax1',
  headerName: 'Fax',
  initialHide: true,
};
